import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";
import coronaTest from '../../static/corona-test.svg';
import CloseIcon from '../../static/close-icon.svg';

import './styles.scss';

Modal.setAppElement("#root");
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.3)",
    zIndex: "10000",
    display: "flex",
    flexDirection: "row-reverse",
  },
  content: {
    position: "initial",
    border: "none",
    borderRadius: "none",
    width: "450px",
    padding: "0px",
    overflowY: "scroll",
  }
};

const questions = [
  `Q1. Do you have fever?`,
  `Q2. Do you have a cough?`,
  `Q3. Do you have a sore throat?`,
  `Q4. Do you have a running nose?`,
  `Q5. Did you come in close contact with a probable or confirmed COVID-19 positive case within the past 14 days?`,
  `Q6. Are you a health worker or a frontline worker like a police official, sanitation worker, journalist or government employee?`,
  `Q7. Do you have shortness of breath?`,
  `Q8.  Would you consider it severe (respiratory rate > 30 per min)?`,
  `Q9.  Are you experiencing mild pneumonia / any problem in breathing?`,
  `Q10. Are you experiencing any of the following conditions? 
Severe pneumonia    
Septic Shock (Low BP and Heart Rate more than 100 per min) `,
  `Q11. Do you have any existing disease?
Blood Pressure
Diabetes
Asthma
Chronic Chest Problem`
];

export default withRouter(function CovidTest(props) {
  const [testCompleted, setTestCompleted] = useState(false);
  const [testStarted, setTestStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(-1);
  const [answers, setAnswers] = useState([]);

  const [messages, setMessages] = useState([]);
  // On change of current question, push next question to messages state (array)
  useEffect(() => {
    if (currentQuestion > -1)
      setMessages([
        ...messages,
        { author: "bot", text: questions[currentQuestion] }
      ]);
  }, [currentQuestion]);

  const handleClose = () => {
    setTestStarted(false);
    setCurrentQuestion(-1);
    setAnswers([]);
    setTestCompleted(false);
    setMessages([]);
    props.onClose();
  };

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current &&
      messagesEndRef.current.scrollIntoView({ block: "end", inline: "nearest", behavior: "smooth" });
  };

  useEffect(scrollToBottom, [messages]);

  const handleResponse = answer => {
    setAnswers([...answers, answer]);
    setMessages([...messages, { author: "user", text: answer ? "Yes" : "No" }]);
    // If Q7 is false, go to Q9 (index 8)
    if (currentQuestion === 6 && !answer) setCurrentQuestion(8);
    // else if last question (length - 1), set test completed
    else if (currentQuestion === questions.length - 1) {
      setTestCompleted(true);
    }
    // else ask the next question
    else setCurrentQuestion(currentQuestion + 1);
  };

  const goBack = (
      <div className="action-test" onClick={handleClose}>
        ←  Go back
      </div>
    ),
    helplineNumbers = (
      <div className="action-test">
        <a
          href="http://health.delhigovt.nic.in/wps/wcm/connect/3dc06b804db318689fefff982ee7a5c7/NCV+HELPLINE.pdf?MOD=AJPERES&lmod=-160400428"
          target="_blank">
          Delhi Govt Helpline Numbers
        </a>
      </div>
    ),
    findTesting = (
      <div className="action-test">
        <a
          target="_blank"
          href="https://www.google.co.in/maps/d/u/0/embed?mid=1yxvXy78wkNoYdtKHYDCPu0lcFfgqB0yq&ll=28.65638808633182%2C77.13615215305117&z=12">
          Find a testing center
        </a>
      </div>
    ),
    findHospital = (
      <div className="action-test">
        <a
          target="_blank"
          href="https://www.google.co.in/maps/d/u/0/viewer?mid=13ibCEHfrj68qIYaG6NWehMA5JVN39hmK&ll=28.61405231828006%2C77.2226960782226&z=11">
          Find a hospital
        </a>
      </div>
    );

  const testResults = testCompleted
    ? !answers[0]
      ? {
          text: `Your infection risk is low, we recommend that you stay at home to avoid any chance of exposure`,
          button1: goBack,
          button2: helplineNumbers
        }
      : answers[1] || answers[2] || answers[3] || answers[4] || answers[5]
      ? {
          text: `Your infection risk is mild. We recommend you visit the nearest COVID Testing Center. A doctor will assess for further evaluation and admission.`,
          button1: findTesting,
          button2: helplineNumbers
        }
      : answers[6] && !answers[7]
      ? {
          text: `Your infection risk is low. We recommend that you stay at home to avoid any chance of exposure and consult a doctor on the phone.`,
          button1: goBack,
          button2: helplineNumbers
        }
      : answers[1] && answers[8]
      ? {
          text: `Your infection risk is moderate. We recommend you visit the nearest COVID Health Center for further evaluation.You can avail ambulance service by dialing 102`,
          button1: findTesting,
          button2: helplineNumbers
        }
      : answers[7] || answers[8] || answers[9]
      ? {
          text: `Your infection risk is high. We recommend you go to the nearest Covid Dedicated Hospital for further management and admission.You can avail ambulance service by dialing 102`,
          button1: findHospital,
          button2: helplineNumbers
        }
      : {
          text: `Your infection risk is low. We recommend that you stay at home to avoid any chance of exposure.`,
          button1: goBack,
          button2: helplineNumbers
        }
    : "Not completed";

  return (
    <Modal
      id={'symptoms-checker-modal'}
      isOpen={props.isOpen}
      style={customStyles}
    >
      <div className="modal-header-wrapper">
        <div className="modal-header">
          <div onClick={handleClose} className="close-button">
            <img src={CloseIcon} />
          </div>
          <div onClick={handleClose} className="back-button">
            <p>
              ←Back
            </p>
          </div>
        </div>
      </div>
      {testStarted ? (
        <div>
          <div className={`message message-padding`}>
            {messages.map((message, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  margin: "14px 0px"
                }}
                className={`d-flex justify-content-${
                  message.author === "bot" ? `start` : `end`
                }`}>
                <div className={`message-${message.author}`}>{message.text}</div>
              </div>
            ))}
          </div>
          {testCompleted ? (
            <>
              <div className="result">
                <h6>Diagnosis</h6>
                <p>{testResults.text}</p>
                {testResults.button1}
                {testResults.button2}
              </div>
            </>
            ) : (
            <div className="response">
              <div
                className="answer-option response-yes"
                onClick={() => {
                  handleResponse(true);
                }}>
                Yes
              </div>
              <div
                className="answer-option response-no"
                onClick={() => {
                  handleResponse(false);
                }}>
                No
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="message-padding">
          <p className="delhi-corona">Delhi Corona</p>
          <p id="find-covid"> Find out if you have Covid</p>
          <img src={coronaTest} alt={"Covid Test Doctors Image"} />
          <div
            onClick={() => {
              setTestStarted(true);
              setCurrentQuestion(0);
            }}
            id="begin-test">
            Begin test
          </div>
          <p id="who">Based on WHO guidelines</p>
        </div>
      )}
      <div ref={messagesEndRef} />
    </Modal>
  );
});
